import React, { useState, useCallback, useEffect, memo } from 'react'
import styled from 'styled-components'
import SwiperCore from 'swiper'
import { EffectFade, FreeMode, Navigation, Pagination, Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { onErrorImg } from '../../js/script'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'

interface ProductDetailCarouselProps {
  imageUrls?: string[]
  isMobile?: boolean
}

const ProductDetailCarousel: React.FC<ProductDetailCarouselProps> = ({ imageUrls, isMobile }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore>()
  const [pictureIdx, setPictureIdx] = useState<string | null>(null)
  const [test, setTest] = useState(false)

  useEffect(() => {
    if (test && !isMobile) {
      setTimeout(() => {
        const thumbsSlides = document.querySelectorAll('.swiper-thumbs .swiper-slide')
        thumbsSlides?.[0]?.classList.add('swiper-slide-thumb-active')
      }, 1000)
    }
  }, [test, isMobile])

  const handleThumbClick = useCallback((el: string) => {
    setPictureIdx(el)
  }, [])

  if (isMobile) {
    return (
      <SwiperWrap slidesPerView={1} autoHeight={false} pagination={true} modules={[Pagination]}>
        {imageUrls &&
          imageUrls.map((el) => (
            <SwiperSlideItem key={el}>
              <img src={el} alt="" onError={onErrorImg} />
            </SwiperSlideItem>
          ))}
      </SwiperWrap>
    )
  }

  return (
    <>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        onInit={() => setTest(true)}
        slidesPerView={6.691999}
        direction="vertical"
        freeMode={true}
        watchSlidesProgress={true}
        modules={[EffectFade, FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {imageUrls &&
          imageUrls.map((el) => (
            <SwiperSlide
              key={el}
              className={pictureIdx === el ? 'swiper-slide-thumb-active' : ''}
              onClick={() => handleThumbClick(el)}
              style={{
                backgroundImage: `url(${el})`,
              }}
            >
              {/* <img src={el} alt="" /> */}
            </SwiperSlide>
          ))}
      </Swiper>
      {/* 비주얼 영역 */}
      <Swiper
        spaceBetween={10}
        effect={'fade'}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[EffectFade, FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {imageUrls &&
          imageUrls.map((el) => (
            <SwiperSlide key={el}>
              <img src={el} alt="" />
            </SwiperSlide>
          ))}
      </Swiper>
    </>
  )
}

export default memo(ProductDetailCarousel)

// 상품 이미지 슬라이드
export const SwiperWrap = styled(Swiper)`
  /* 슬라이드 페이지네이션 */
  & .swiper-pagination {
    display: flex;
    gap: 4px;
    justify-content: center;
    align-items: center;
    bottom: 12px !important;
    /* 슬라이드 페이지 블릿 */
    & .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      opacity: 1;
      background: var(--colBlack);
      opacity: 0.2;
      margin: 0 !important;
    }
    /* 선택된 슬라이드 페이지 블릿 */
    & .swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
`
// 슬라이드 각 아이템
export const SwiperSlideItem = styled(SwiperSlide)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
export const SliceItem = styled.div``
